import { render } from "./ZoneWizardPhysicalNetworkSetupStep.vue?vue&type=template&id=68d2257d&scoped=true"
import script from "./ZoneWizardPhysicalNetworkSetupStep.vue?vue&type=script&lang=js"
export * from "./ZoneWizardPhysicalNetworkSetupStep.vue?vue&type=script&lang=js"

import "./ZoneWizardPhysicalNetworkSetupStep.vue?vue&type=style&index=0&id=68d2257d&scoped=true&lang=less"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d2257d"]])

export default __exports__